import React from "react";

import LandingPagePublicLayout from "./layouts/publicLayout/LandingPagePublicLayout";

export default function LandingPageLayout(props) {
  const menuItems = [
    {
      menuKey: "about",
      label: "Comment ça marche",
      path: "",
    },
    {
      menuKey: "influencers",
      label: "Influenceurs",
      path: "influencers",
    },
    {
      menuKey: "companies",
      label: "Entreprises",
      path: "companies",
    },
    {
      menuKey: "contact",
      label: "Contact",
      path: "contact",
    },
  ];

  return <LandingPagePublicLayout {...props} menuItems={menuItems} />;
}
